// Canonical mapping of original_ingredients to approved ingredients
const canonicalIngredientMap = {
    "Adenosine 5'-Monophosphate": "Nucleotides",
    "Adenosine-5'-monophosphate": "Nucleotides",
    "Adenosine-5\u2019-monophosphate": "Nucleotides",
    "adenosine-5\u2032-monophosphate": "Nucleotides",
    "and Antioxidants (Sunflower Lecithin": "Sunflower Lecithin",
    "and Vitamin B12": "Vitamin B1",
    "antioxidant (ascorbyl palmitate)": "Vitamin C",
    "Antioxidant (Ascorbyl Palmitate)": "Vitamin C",
    "antioxidant (sodium ascorbate)": "Vitamin C",
    "Antioxidant (Vitamin C)": "Vitamin C",
    "Antioxidants (Sunflower Lecithin": "Sunflower Lecithin",
    "Arachidonic Acid": "ARA",
    "arachidonic acid (AA)": "ARA",
    "arachidonic acid oil (AA)": "ARA",
    "arachidonic acid rich oil (AA)": "ARA",
    "ascorbic acid rich oil sodium L-ascorbate": "Vitamin C",
    "ascorbyl palmitate": "Ascorbyl Palmitate",
    "beta-palmitate (from palm oil and sunflower Oil": "Beta-Palmitate",
    "Beta-Palmitate (From Palm Oil And Sunflower Oil": "Beta-Palmitate",
    "Bifidobacterium breve M-16V": "Bifidobacterium Breve M-16V",
    "biotin": "Biotin",
    "Biotin": "Biotin",
    "Biotine": "Biotin",
    "Calcium": "Calcium",
    "calcium": "Calcium",
    "Calcium carbonate": "Calcium",
    "Calcium Carbonate": "Calcium",
    "calcium carbonate": "Calcium",
    "calcium chloride": "Calcium",
    "Calcium Chloride": "Calcium",
    "Calcium Citrate": "Calcium",
    "Calcium Citrates": "Calcium",
    "calcium D-pantothenate": "Calcium",
    "Calcium D-Pantothenate": "Calcium",
    "Calcium Hydroxide": "Calcium",
    "Calcium L-Methylfolate D-biotin": "Calcium",
    "Calcium Lactate": "Calcium",
    "Calcium Orthophosphate": "Calcium",
    "calcium orthophosphate": "Calcium",
    "Calcium Orthophosphates": "Calcium",
    "Calcium Pantothenate": "Calcium",
    "Calcium Phosphate": "Calcium",
    "Calcium phosphate": "Calcium",
    "Calcium Salts": "Calcium",
    "Calcium Salts of Citric Acid": "Citric Acid",
    "calcium salts of orthophosphoric acid": "Calcium",
    "Calcium Salts of Orthophosphoric Acid": "Calcium",
    "Calcium-L-Methylfolate": "Calcium",
    "calcium-L-methylfolate3": "Calcium",
    "Carbonate Magnesium": "Magnesium",
    "chloride": "Chloride",
    "choline": "Choline",
    "Choline": "Choline",
    "Choline Bitartrate": "Choline",
    "choline bitartrate": "Choline",
    "choline chloride": "Choline",
    "Choline Chloride": "Choline",
    "Choline chloride": "Choline",
    "Choline Hydrogen Tartrate": "Choline",
    "Coconut oil": "Coconut Oil",
    "coconut oil": "Coconut Oil",
    "Coconut Oil": "Coconut Oil",
    "Coconut Rapeseed)": "Rapeseed Oil",
    "contains emulsifier (soy lecithin)": "Emulsifiers",
    "contains fish oil": "Fish Oil",
    "copper": "Copper",
    "Copper Sulfate": "Copper",
    "copper sulfate": "Copper",
    "Copper Sulphate": "Copper",
    "copper sulphate": "Copper",
    "Copper sulphate": "Copper",
    "Cream (Milk)": "Cow Milk",
    "Cupric Sulfate": "Copper",
    "cupric sulphate": "Copper",
    "Cyanocobalamin": "Vitamin B12",
    "cyanocobalamin)": "Vitamin B12",
    "cyanocobalamine": "Vitamin B12",
    "Cytidine 5'-Monophosphate": "Nucleotides",
    "Cytidine-5'-monophosphate": "Nucleotides",
    "Cytidine-5-monophosphate": "Nucleotides",
    "Cytidine-5\u2019-monophosphate": "Nucleotides",
    "D-Biotin": "Biotin",
    "D-biotin": "Biotin",
    "Dairy-based blend (of which 25% is fermented) [Lactose (from milk)": "Cow Milk",
    "Dairy-Based Blend (of which 28% is Fermented) [Lactose (from Milk)": "Cow Milk",
    "Dairy-based blend (of which 29% is fermented) [Lactose (from milk)": "Cow Milk",
    "Demineralised Goat Whey Powder (from Milk)": "Goat Milk",
    "Demineralised Whey (from Milk)": "Whey Powder",
    "Demineralised whey (from milk)": "Whey Powder",
    "Demineralised Whey Powder (from Milk)": "Whey Powder",
    "Demineralized Milk Whey Powder (enriched in alpha lactalbumin)": "Whey Powder",
    "Dicalcium Phosphate": "Calcium",
    "Disodium Guanosine-5 monophosphate)": "Nucleotides",
    "Disodium Guanosine-5 Monophosphate": "Nucleotides",
    "Disodium Guanosine-5'-monophosphate)": "Nucleotides",
    "Disodium Guanosine-5'-monophosphate": "Nucleotides",
    "Disodium guanosine-5-monophosphate)": "Nucleotides",
    "Disodium guanosine-5-monophosphate": "Nucleotides",
    "Disodium Guanosine-5’-Monophosphate": "Nucleotides",    
    "disodium Guanosine-5\u2019 monophosphate": "Nucleotides",
    "disodium Guanosine-5\u2019 monophosphate)": "Nucleotides",
    "Disodium Guanosine-5\u2019-monophosphate)": "Nucleotides",
    "Disodium Inosine-5'-monophosphate": "Nucleotides",
    "Disodium Inosine-5-monophosphate": "Nucleotides",
    "Disodium inosine-5-monophosphate": "Nucleotides",
    "Disodium Inosine-5\u2018-monophosphate": "Nucleotides",
    "disodium Inosine-5\u2019-monophosphate": "Nucleotides",
    "Disodium uridine-5'-monophosphate": "Nucleotides",
    "Disodium Uridine-5'-monophosphate": "Nucleotides",
    "Disodium Uridine-5-monophosphate": "Nucleotides",
    "Disodium Uridine-5\u2019-monophosphate": "Nucleotides",
    "disodium Uridine-5\u2019-monophosphate": "Nucleotides",
    "dl-alpha tocopherol": "Vitamin E",
    "docosahexaenoic acid rich oil (DHA)": "DHA",
    "dried glucose syrup": "Glucose Syrup",
    "Emulsifier (Citric Acid Ester of Mono and Di-Glycerides)": "Citric Acid",
    "emulsifier (soy lecithin)": "Emulsifiers",
    "Emulsifier (Soy Lecithin)": "Emulsifiers",
    "Emulsifier (Soy lecithin)": "Emulsifiers",
    "emulsifier citric acid esters of mono and diglycerides of fatty acids": "Citric Acid",
    "Emulsifier Citric Acid Esters Of Mono And Diglycerides Of Fatty Acids": "Citric Acid",
    "Emulsifier Lecithins": "Emulsifiers",
    "Emulsifier: Citric Acid Esters Of Mono AND Diglycerides Of Edible Fatty Acids": "Citric Acid",
    "Emulsifier: Citric Acid Esters Of Mono And Diglycerides Of Edible Fatty Acids": "Citric Acid",
    "Emulsifier: Citric Acid Esters Of Mono AND Diglycerides Of Fatty Acids": "Citric Acid",
    "emulsifying agent: citric acid esters of mono and diglycerides": "Citric Acid",
    "emulsifying agent: citric acid esters of mono and diglycerides of fatty acids": "Citric Acid",
    "ferrous sulfate": "Iron",
    "Ferrous Sulfate": "Iron",
    "ferrous sulphate": "Iron",
    "Ferrous Sulphate": "Iron",
    "Ferrous sulphate": "Iron",
    "Fish Oil": "Fish Oil",
    "fish oil": "Fish Oil",
    "Fish oil": "Fish Oil",
    "Fish Oil2": "Fish Oil",
    "Fish Oil\u00b9": "Fish Oil",
    "folic acid": "Folic Acid",
    "Folic acid": "Folic Acid",
    "Folic Acid": "Folic Acid",
    "folic acid calcium-L-methyfolate (Metafolin)": "Metafolin",
    "Fructo-oligosaccharides": "Galacto-Oligosaccharides",
    "Fructo-Oligosaccharides": "Galacto-Oligosaccharides",
    "Fructo-Oligosaccharides (FOS)": "Galacto-Oligosaccharides",
    "fructo-oligosaccharides (FOS)": "Galacto-Oligosaccharides",
    "Fructo-oligosaccharides (FOS)": "Galacto-Oligosaccharides",
    "Galacto-Oligosacchardies (from Milk*)": "Galacto-Oligosaccharides",
    "Galacto-oligosaccharides (from Milk)": "Galacto-Oligosaccharides",
    "Galacto-Oligosaccharides (from Milk*)": "Galacto-Oligosaccharides",
    "Galacto-Oligosaccharides (GOS) (from Milk)": "Galacto-Oligosaccharides",
    "Galacto-oligosaccharides (GOS) (from milk)": "Galacto-Oligosaccharides",
    "galacto-oligosaccharides (GOS) from milk": "Galacto-Oligosaccharides",
    "Galacto-oligosaccharides (Milk)": "Galacto-Oligosaccharides",
    "galacto-oligosaccharides from lactose": "Galacto-Oligosaccharides",
    "Galacto-oligosaccharides from Lactose": "Galacto-Oligosaccharides",
    "Galacto-oligosaccharides from Organic Lactose": "Galacto-Oligosaccharides",
    "galacto-oligosaccharides* from lactose": "Galacto-Oligosaccharides",
    "Galactooligosaccharides From Lactose": "Galacto-Oligosaccharides",
    "Galactooligosaccharides* From Lactose": "Galacto-Oligosaccharides",
    "Organic Galacto-Oligosaccharides (Obtained From Organic Lactose)": "Galacto-Oligosaccharides",
    "Glucose Syrup": "Glucose Syrup",
    "goat whey protein concentrate powder (milk)": "Goat Milk",
    "goat whey protein concentrate powder from milk": "Goat Milk",
    "Goat's milk": "Goat Milk",
    "goat's milk powder": "Goat Milk",
    "Guanosine 5'-Monophosphate Sodium Salt": "Nucleotides",
    "Guanosine 5'-Monophosphate Sodium salt": "Nucleotides",
    "guanosine-5\u2032-monophosphate": "Nucleotides",
    "High Oleic Sunflower Oil": "Sunflower Oil",
    "High oleic sunflower oil": "Sunflower Oil",
    "hydrolysed whey protein": "Whey Powder",
    "Hydrolysed Whey Protein Concentrate (from Milk*)": "Whey Powder",
    "Hydrolyzed Whey Protein": "Whey Powder",
    "hydrolyzed whey proteins": "Whey Powder",
    "Inosine 5'-Monophosphate Sodium Salt": "Nucleotides",
    "Inosine 5-'Monophosphate Sodium Salt": "Nucleotides",
    "inosine-5\u2032-monophosphate": "Nucleotides",
    "inositol": "Inositol",
    "Inositol": "Inositol",
    "Inositol L-Tyrosine": "Inositol",
    "Inositol Oil from Mortierella Alpina": "Mortierella Alpina Oil",
    "iodine": "Iodine",
    "iron": "Iron",
    "Iron Lactate": "Iron",
    "Iron Pyrophosphate": "Phosphorus",
    "iron sulfate": "Iron",
    "Iron Sulfate": "Iron",
    "L-Ascorbic Acid": "Vitamin C",
    "L-ascorbic acid": "Vitamin C",
    "L-Camitine": "Amino Acids",
    "L-carnitine": "Amino Acids",
    "L-Carnitine": "Amino Acids",
    "L-carnitine L-tartrate": "Amino Acids",
    "L-Carnitine. Dl-A-Tocopheryl Acetate": "Amino Acids",
    "L-cystine": "Amino Acids",
    "L-Cystine": "Amino Acids",
    "L-histidine": "Amino Acids",
    "L-Histidine": "Amino Acids",
    "L-Isoleucine": "Amino Acids",
    "L-Phenylalanine": "Amino Acids",
    "L-phenylalanine": "Amino Acids",
    "L-tryptophan": "Amino Acids",
    "L-Tryptophan": "Amino Acids",
    "L-tryptophan acid": "Amino Acids",
    "L-Tyrosine": "Amino Acids",
    "L-tyrosine": "Amino Acids",
    "lactose": "Lactose",
    "Lactose": "Lactose",
    "Lactose (from Milk)": "Lactose",
    "Lactose (Milk)": "Lactose",
    "lactose from milk": "Lactose",
    "lactose galacto-oligosaccharides": "Galacto-Oligosaccharides",
    "laurol-carnitine L-tartrate": "Amino Acids",
    "LCP Oils (Oil from the Microalgae Schizochytrium sp.": "Algae Oil",
    "Less Than 2% of: Calcium Phosphate": "Calcium",
    "long chain fructo-oligosaccharides": "Galacto-Oligosaccharides",
    "magnesium": "Magnesium",
    "Magnesium Carbonate": "Magnesium",
    "magnesium carbonate": "Magnesium",
    "Magnesium Chloride": "Magnesium",
    "magnesium chloride": "Magnesium",
    "Magnesium chloride": "Magnesium",
    "Magnesium hydrogen phosphate": "Magnesium",
    "Magnesium Hydrogen Phosphate": "Magnesium",
    "Magnesium Sulfate": "Magnesium",
    "Magnesium Sulphate": "Magnesium",
    "Maize Starch": "Starch",
    "Maltodextrin": "Maltodextrin",
    "maltodextrin": "Maltodextrin",
    "manganese": "Manganese",
    "Manganese Sulfate": "Manganese",
    "manganese sulfate": "Manganese",
    "Manganese Sulfate Potassium Iodide": "Potassium",
    "Manganese Sulphate": "Manganese",
    "manganese sulphate": "Manganese",
    "Manganese sulphate": "Manganese",
    "Marine Fish Oil Powder (Source of Docosahexaenoic Acid)": "Fish Oil",
    "Metafolin (Calcium L-Methylfolate)": "Metafolin",
    "Metafolin (Calcium L-methylfolate)": "Metafolin",
    "Milk protein": "Cow Milk",
    "Milk solids": "Cow Milk",
    "minerals (calcium carbonate": "Calcium",
    "minerals (tricalcium phosphate": "Calcium",
    "mixed tocopherols": "Vitamin E",
    "Mortierella Alpina Oil": "Mortierella Alpina Oil",
    "Mortierella alpina oil": "Mortierella Alpina Oil",
    "Mortierella Alpina Oil Powder (Source of Arachidonic Acid)": "Mortierella Alpina Oil",
    "Mortierella Alpina Oil Powder (Source of Docosahexaenoic Acid)": "Mortierella Alpina Oil",
    "Mortierella alpina-oil": "Mortierella Alpina Oil",
    "Natural Lactic Acid Culture (Limosillactobacillus Fermentum Hereditum Vitamin B (Riboflavin)": "Vitamin B2",
    "Niacin": "Vitamin B3",
    "niacin": "Vitamin B3",
    "Niacin (Vitamin B3)": "Vitamin B3",
    "niacin (nicotinamide)": "Vitamin B3",
    "niacinamide": "Vitamin B3",
    "nicotinamide": "Nicotinamide",
    "Nicotinamide": "Nicotinamide",
    "Oil Extracted from the Microalgae Schizochytrium Sp.2": "Algae Oil",
    "Oil extracted from the Schizochytrium Microalgae Sp.2": "Algae Oil",
    "Oil from Mortierella Alpina": "Mortierella Alpina Oil",
    "Oil from Mortierella alpina": "Mortierella Alpina Oil",
    "Oil From Mortierella Alpina": "Mortierella Alpina Oil",
    "Oil from Mortierella Alpina (Milk)": "Mortierella Alpina Oil",
    "Oil from Mortierella Alpina)": "Mortierella Alpina Oil",
    "Oil From The Microalga Schizochytrium Sp.2": "Algae Oil",
    "Oil from the Microalgae Schizochytrium sp.": "Algae Oil",
    "Oil from the microalgae Schizochytrium sp.": "Algae Oil",
    "Oil from the Microalgae Schizochytrium sp. (Milk)": "Algae Oil",
    "Oil from the Microalgae Schizochytrium sp.2": "Algae Oil",
    "Oil from the Microalgae Schizochytrium Sp.2": "Algae Oil",
    "Oil From the Microalgae Schizochytrium Sp.2": "Algae Oil",
    "Organic Demineralised Milk": "Cow Milk",
    "Organic Demineralised Milk Whey Protein Powder": "Cow Milk",
    "Organic DHA": "DHA",
    "Organic Fish Oil": "Fish Oil",
    "Organic Galacto-oligosaccharides (from Milk)": "Galacto-Oligosaccharides",
    "Organic Galacto-oligosaccharides (from milk)": "Galacto-Oligosaccharides",
    "Organic Galacto-oligosaccharides from Organic Lactose": "Galacto-Oligosaccharides",
    "organic galacto-oligosaccharides from organic lactose": "Galacto-Oligosaccharides",
    "Organic Lactose": "Lactose",
    "organic lactose": "Lactose",
    "Organic Lactose (from Milk)": "Lactose",
    "Organic Maltodextrin": "Maltodextrin",
    "Organic Maltodextrin (from Corn)": "Maltodextrin",
    "organic rapeseed oil": "Rapeseed Oil",
    "Organic Rapeseed Oil": "Rapeseed Oil",
    "Organic skimmed milk": "Cow Milk",
    "Organic Skimmed Milk": "Cow Milk",
    "Organic starch": "Starch",
    "Organic Starch": "Starch",
    "Organic Sunflower Oil": "Sunflower Oil",
    "organic sunflower Oil": "Sunflower Oil",
    "Organic Whey": "Whey Powder",
    "organic whey product": "Whey Powder",
    "Organic Whey Product": "Whey Powder",
    "Organic Whey Product (Partially Demineralized Whey Powder)": "Whey Powder",
    "Organic Whey Products (Partially Demineralized Whey Powder)": "Whey Powder",
    "Organic Whole Goat's Milk": "Goat Milk",
    "Organic Whole Goat's Milk Powder": "Goat Milk",
    "Organic Whole Milk": "Cow Milk",
    "Orthophosphoric Acid": "Orthophosphoric Acid",
    "Palm Oil": "Palm Oil",
    "palm oil": "Palm Oil",
    "pantothenic acid": "Vitamin B5",
    "Pantothenic Acid": "Vitamin B5",
    "Pantothenic acid": "Vitamin B5",
    "pantothenic acid (calcium D-pantothenate)": "Vitamin B5",
    "pantothenic acid (calcium-D-pantothenate)": "Vitamin B5",
    "Pantothenic acid (Vitamin B5)": "Vitamin B5",
    "Partially Hydrolysed Whey Protein (Milk)": "Whey Powder",
    "Pasteurized Goat Milk Powders": "Goat Milk",
    "Pasteurized Whole Goat Milk": "Goat Milk",
    "phosphorus": "Phosphorus",
    "phytomenadione D-biotin": "Biotin",
    "Potassium": "Potassium",
    "Potassium chloride": "Potassium",
    "Potassium Chloride": "Potassium",
    "potassium chloride": "Potassium",
    "Potassium citrate": "Potassium",
    "Potassium Citrate": "Potassium",
    "potassium citrate": "Potassium",
    "Potassium Dihydrogen Phosphate": "Potassium",
    "Potassium Hydroxide": "Potassium",
    "potassium hydroxide": "Potassium",
    "Potassium Iodate": "Potassium",
    "potassium iodate": "Potassium",
    "potassium iodide": "Potassium",
    "Potassium Iodide": "Potassium",
    "Potassium iodide": "Potassium",
    "Potassium lodide": "Potassium",
    "Potato Starch": "Starch",
    "Pyridoxine Hydrochloride": "Chloride",
    "pyridoxine hydrochloride": "Chloride",
    "Rapeseed Oil": "Rapeseed Oil",
    "rapeseed oil": "Rapeseed Oil",
    "Rapeseed oil": "Rapeseed Oil",
    "riboflavin": "Vitamin B2",
    "Riboflavin": "Vitamin B2",
    "short chain galac-to-oligosaccharides": "Galacto-Oligosaccharides",
    "short chain galacto-oligosaccharides (milk)": "Galacto-Oligosaccharides",
    "Single Cell Oil": "Algae Oil",
    "Skimmed goat milk": "Goat Milk",
    "skimmed goat milk": "Goat Milk",
    "Skimmed goat's milk": "Goat Milk",
    "Skimmed milk": "Cow Milk",
    "Skimmed Milk": "Cow Milk",
    "Skimmed Milk Powder": "Cow Milk",
    "sodium": "Sodium",
    "Sodium Ascorbate": "Sodium",
    "sodium ascorbate": "Sodium",
    "Sodium Ascorbate (Vitamin C)": "Sodium",
    "sodium caseinate": "Whey Powder",
    "sodium caseinate (milk)": "Whey Powder",
    "sodium chloride": "Sodium",
    "Sodium Chloride": "Sodium",
    "Sodium chloride": "Sodium",
    "Sodium Citrate": "Sodium",
    "Sodium citrate": "Sodium",
    "Sodium CitratE": "Sodium",
    "sodium citrate": "Sodium",
    "sodium hydroxide": "Sodium",
    "Sodium Hydroxide": "Sodium",
    "sodium L-ascorbate": "Sodium",
    "sodium selenate": "Sodium",
    "Sodium Selenate": "Sodium",
    "sodium selenite": "Sodium",
    "Sodium selenite": "Sodium",
    "Sodium Selenite": "Sodium",
    "Soluble Dextrin": "Soluble Dextrin",
    "soybean oil": "Soybean Oil",
    "Starch": "Starch",
    "starch": "Starch",
    "sunflower Oil": "Sunflower Oil",
    "Sunflower Oil": "Sunflower Oil",
    "Sunflower oil": "Sunflower Oil",
    "sunflower oil": "Sunflower Oil",
    "Taurine": "Taurine",
    "taurine": "Taurine",
    "Thiamin": "Vitamin B1",
    "Thiamin Hydrochloride": "Chloride",
    "Thiamine": "Vitamin B1",
    "thiamine hydrochloride": "Chloride",
    "Thickener (Carob Bean Gum)": "Thickener",
    "Tocopherol-Rich Extract)": "Vitamin E",
    "Tocopherol-Rich Extract). Pasteurized Goat Milk Powders": "Goat Milk",
    "Tri-Calcium Phosphate": "Calcium",
    "tricalcium phosphate": "Calcium",
    "tripotassium citrate": "Potassium",
    "trisodium citrate": "Sodium",
    "Uridine 5'-Monophosphate Sodium Salt": "Nucleotides",
    "uridine-5\u2019-monophosphate": "Nucleotides",
    "Vegetable Oil Blend (High Oleic Sunflower Oil": "Sunflower Oil",
    "Vitamin A": "Vitamin A",
    "vitamin A": "Vitamin A",
    "Vitamin A (Retinyl Acetate)": "Vitamin A",
    "Vitamin B": "Vitamin B",
    "vitamin B": "Vitamin B",
    "Vitamin B (Riboflavin)": "Vitamin B2",
    "vitamin B1": "Vitamin B1",
    "Vitamin B1": "Vitamin B1",
    "Vitamin B1 (Cyanocobalamin)": "Vitamin B1",
    "Vitamin B1-Thiamine": "Vitamin B1",
    "vitamin B12": "Vitamin B12",
    "Vitamin B12": "Vitamin B12",
    "Vitamin B12 (Cyanocobalamin)": "Vitamin B1",
    "vitamin B2": "Vitamin B2",
    "Vitamin B2": "Vitamin B2",
    "Vitamin B3": "Vitamin B3",
    "Vitamin B5": "Vitamin B5",
    "Vitamin B6": "Vitamin B6",
    "vitamin B6": "Vitamin B6",
    "Vitamin C": "Vitamin C",
    "vitamin C": "Vitamin C",
    "Vitamin C (Sodium L-Ascorbate)": "Sodium",
    "Vitamin C (Sodium L-ascorbate)": "Sodium",
    "Vitamin D": "Vitamin D3",
    "vitamin D": "Vitamin D3",
    "vitamin D (cholecalciferol)": "Vitamin D3",
    "Vitamin D (Cholecalciferol)": "Vitamin D3",
    "Vitamin D3": "Vitamin D3",
    "Vitamin E": "Vitamin E",
    "vitamin E": "Vitamin E",
    "Vitamin K": "Vitamin K",
    "vitamin K": "Vitamin K",
    "Vitamin K1": "Vitamin K",
    "Whey concentrate (from milk)": "Whey Powder",
    "Whey Concentrate (from Milk)": "Whey Powder",
    "Whey concentrate) (from milk)": "Whey Powder",
    "Whey products (Demineralised whey": "Whey Powder",
    "whey protein": "Whey Powder",
    "whey Protein": "Whey Powder",
    "Whey Protein": "Whey Powder",
    "Whey Protein (from Milk)": "Whey Powder",
    "whey protein (milk)": "Whey Powder",
    "Whey Protein Concentrate Alpha-actalbumin (from Milk)": "Whey Powder",
    "Whey Protein Concentrate Alpha-lactalbumin (Milk)": "Whey Powder",
    "Whey Protein Hydrolysate": "Whey Powder",
    "Whey Protein Hydrolysate (from Milk)": "Whey Powder",
    "Whey Protein Powder": "Whey Powder",
    "Whole Goat Milk": "Goat Milk",
    "Whole goat milk powder": "Goat Milk",
    "Whole Milk (107g per 100g)": "Cow Milk",
    "Whole Milk (173g liquid Milk per 100g)": "Cow Milk",
    "Whole Milk (190g per 100g)": "Cow Milk",
    "Whole Milk Powder": "Cow Milk",
    "Whole Milk": "Cow Milk",
    "zinc": "Zinc",
    "Zinc Oxide": "Zinc",
    "zinc sulfate": "Zinc",
    "Zinc Sulfate": "Zinc",
    "Zinc Sulphate": "Zinc",
    "Zinc sulphate": "Zinc",
    "zinc sulphate": "Zinc",
    "antioxidant": "Vitamin E",
    "antioxidant,": "Vitamin E",
    "cholecalcalcalin": "Vitamin D3",
    "cholecalciferol": "Vitamin D3",
    "Cholecalciferol": "Vitamin D3",
    "D-biotol": "Biotin",
    "Dl-A-Tocopheryl Acetate": "Vitamin E",
    "DL-\u03b1 tocopheryl acetate": "Vitamin E",
    "DL-\u03b1-tocopheryl acetate": "Vitamin E",
    "Docosahexaenoic Acid": "DHA",
    "dried omega LCPUFAs": "DHA",
    "high sn-2 palmitic acid oil": "Beta-Palmitate",
    "in Lositolalauranine-tartrate": "Inositol",
    "L Carnitine": "Amino Acids",
    "L Phenylalanine": "Amino Acids",
    "L Tyrosine": "Amino Acids",
    "L-A-Tocopheryl Acetate": "Vitamin E",
    "L-Arginine": "Amino Acids",
    "L-arginine": "Amino Acids",
    "L-Lositol-carnine-carnine": "Amino Acids",
    "L-methylfolate": "Metafolin",
    "Lactic Acid Stabilizer": "Lactic Acid",
    "laurolan": "Emulsifiers",
    "Lositin": "Emulsifiers",
    "M. Alpina Oil": "Mortierella Alpina Oil",
    "M. Alpina Oil(\u00b9": "Mortierella Alpina Oil",
    "Mortierella Alpina Oil (ARA)": "Mortierella Alpina Oil",
    "Milk flavoring": "Cow Milk",
    "natural culture of lactic acid (Limosilactobacillus fermentum hereditum)": "Lactic Acid",
    "Natural Lactic Acid Culture (Lactobacillus Fermentum Hereditum)": "Lactic Acid",
    "Natural Lactic Acid Culture (Limosilactobacillus Fermentum Hereditu)": "Lactic Acid",
    "Natural Lactic Acid Cultures (Limosilactobacillus fermentum hereditum)": "Lactic Acid",
    "Natural Lactic Acid Cultures (Limosilactobacillus Fermentum Hereditum)": "Lactic Acid",
    "Natural Lactic Ferments (Limosilactobacillus Fermentum Hereditum)": "Lactic Acid",
    "Lactic Acid Culture [Hereditum Lactobacillus Fermentum CECT5716]": "Lactic Acid",
    "Natural Lactic Acid Culture (Limosillactobacillus Fermentum Hereditum)": "Lactic Acid",
    "Oil from Morterella Alpina (Milk)": "Mortierella Alpina Oil",
    "Organic Palm Oil": "Palm Oil",
    "organic palm oil": "Palm Oil",
    "Organic Skim Milk": "Cow Milk",
    "Organic skimmed": "Cow Milk",
    "Organic Skimmed A2 Milk": "Cow Milk",
    "Organic Vegetable Oils [Organic Palm Oil": "Palm Oil",
    "palm kernel oil": "Palm Oil",
    "phytomenadione": "Vitamin K",
    "Phytonadione": "Vitamin K",
    "Retinyl Acetate": "Vitamin A",
    "retinyl acetate": "Vitamin A",
    "selenium": "Selenium",
    "Skim Milk": "Cow Milk",
    "Stabilizer Lactic Acid": "Lactic Acid",
    "sun_ower Oil": "Sunflower Oil"
};